export const GENDER_OPTIONS = [
  {
    label: "Femme",
    value: "F",
  },
  {
    label: "Homme",
    value: "H",
  },
];
